export default __webpack_public_path__ + "static/media/stirring.1dcad7d7.gif";